import React from "react";

const NotFoundPage = () => {
  return (
    <div className="container text-center" style={{ marginTop: "50px" }}>
      <h1>Página não encontrada</h1>
      <p>A página que você está procurando não existe.</p>
    </div>
  );
};

export default NotFoundPage;
